export const nameRgx = /^[a-zA-ZÀ-ÿ]+(?:[ '-][a-zA-ZÀ-ÿ]+)*$/;
export const mobileRgx = /04[0-9][0-9]\s?([0-9]{3})\s?([0-9]{3})/;
export const emailRgx = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/i;
export const dateRgx =
	/^([0-2][0-9]|(3)[0-1])(\/)(((0)[1-9])|((1)[0-2]))(\/)\d{4}$/;
export const alphabetAndSpaceHyphen = /^[A-Za-z- ]+$/i;
export const alphanumeric = /^[a-z0-9]+$/i;
export const alphanumericAndSpaceHyphen = /^[A-Za-z0-9- ]+$/i;
export const alphanumericAndSpecial = /^[ A-Za-z0-9()[\]+\-*/%!@#%'‘’]*$/i;
export const noNumber = /^([^0-9]*)$/;
export const numberOnly = /^\d+$/;

export const isMobileNumberValid = (value) => mobileRgx.test(value);
export const isEmailValid = (value) => emailRgx.test(value);
